// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2Kfwo","fileBtn":"File_fileBtn__3p5wF","closeBtn":"File_closeBtn__3EDqk","fileSelected":"File_fileSelected__jCP27","disabled":"File_disabled__3dcGn"};